import { currentRole, isAdmin, canOperate } from './roles';

/** Routes only platform admins should see / open. */
export const ADMIN_PATHS = [
  '/dashboard',
  '/users',
  '/skills',
  '/packages',
  '/suites',
  '/overlays',
  '/signups',
  '/customers',
  '/workspaces',
  '/entitlements',
  '/credit-pools',
  '/agents',
  '/integrations',
  '/audit',
  '/reports',
  '/routing',
];

/** Day-to-day product routes for operators / viewers (and admins). */
export const USER_PATHS = ['/goals', '/home', '/tasks', '/runs', '/approvals'];

export function isAdminPath(pathname) {
  return ADMIN_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

export function defaultHomePath() {
  return isAdmin() ? '/dashboard' : '/home';
}

export function canAccessPath(pathname) {
  if (!pathname || pathname === '/login' || pathname === '/welcome') return true;
  if (isAdmin()) return true;
  // Non-admins: user product only
  if (USER_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    if (pathname.startsWith('/approvals') && !canOperate()) return false;
    return true;
  }
  return false;
}

export function navMode() {
  return isAdmin() ? 'admin' : 'user';
}

export function roleHint() {
  return currentRole() || 'viewer';
}
